<template>
    <div class="tab-pane fade show active overflow-hidden " role="tabpanel" id="group-vlist-container">
        <UseVirtualList v-if="groups.length" ref="virtualList" :list="groups" :options="{itemHeight: 88}" :style="{ height: listHeight }" @scroll.passive="emit('scroll', $event)" class="list-unstyled chat-list chat-group-list px-2 mt-3 custom-scrollbar">
            <template #default="{data: group}">
                <GroupItem v-if="group" :key="group.id" :group="group"/>
            </template>
        </UseVirtualList>

        <div v-if="!groups.length && !internalChatStore.isInternalChatMode" class="empty_state text-center">
            <div class="empty_state_box_img mt-4">
                <img  src="/img/empty_state.png" style="width: 50px !important">
            </div>
            <p class="mt-2" style="color: #9aa1b954;">No momento, não existem grupos ativos.</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import GroupItem from './GroupItem.vue';
import { useInternalChatStore } from '../../../../stores/app/chatInternoStore';
import { UseVirtualList } from '@vueuse/components';
import { PropType, ref, watch } from 'vue';
import { Chat } from '@/mocks/app/mockChatData';
import { vListCalcHeight } from '@/utils/v-list-calc-height.composable';
import { useChatStore } from '@/stores/app/chatStore';
import { useUiStore } from '@/stores/app/uiStore';

const uiStore = useUiStore();
const chatStore = useChatStore();
const internalChatStore = useInternalChatStore();

const props = defineProps({ 
    groups: {type: Array as PropType<Chat[]>, default: () => []},
    resetScroll: { type: Number, default: 0 },
})

const emit = defineEmits({ 
    'scroll'(e: Event) { return e },
});


const virtualList = ref<any>(null);
watch(() => props.resetScroll, () => virtualList.value?.scrollTo({top: 0, behavior: 'smooth'}));

const { listHeight } = vListCalcHeight('group-vlist-container', chatStore, { vList: virtualList, list: () => props.groups, triggersToRecalc: [() => uiStore.activeTab] });
</script>
<style scoped>
.custom-scrollbar {
    overflow-y: auto;
    margin-right: 2px;
}
.custom-scrollbar::-webkit-scrollbar { width: 6px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e7eaee; border-radius: 4px; }
[data-bs-theme="dark"] .custom-scrollbar::-webkit-scrollbar-thumb { background: #3b4045; }
</style>